export function initBrowserPolyfills() {
  if (typeof window === 'undefined') {
    return;
  }

  if (!window.requestIdleCallback) {
    window.requestIdleCallback = function (cb: IdleRequestCallback): number {
      const start = Date.now();

      return window.setTimeout(() => {
        cb({
          didTimeout: false,
          timeRemaining() {
            return Math.max(0, 50 - (Date.now() - start));
          },
        });
      }, 1);
    };
  }

  if (!window.cancelIdleCallback) {
    window.cancelIdleCallback = function (id: number) {
      window.clearTimeout(id);
    };
  }
}